
export const isJSON = (string) => {
  try {
    JSON.parse(string)
    return true
  } catch (e) {
    return false
  }
}

export const capitalizeFirstLetter = (string) => {
  if (!string) return ''
  return string.charAt(0).toUpperCase() + string.slice(1)
}
